import WelcomeSceneWrapper from "./WelcomeSceneWrapper";
import App from './App.js';
import { useState } from './sciugo-hooks';
import { useEffect } from 'react';
import { useStore, useDispatch, useSelector } from 'react-redux';
import A from './ActionCreators';
import TestFallback from './TestFallback';
import { ErrorBoundary } from 'react-error-boundary';
import ComponentWrapper from './ComponentWrapper';

import { FIGURE_BUILDER, WELCOME, ANNOTATION, FIGURES_AND_PANELS, QUANTIFICATION, FIGURE} from './UIConstants';


export default function AppWrapper({}){

  const [appRenderKey,setAppRenderKey] = useState(Math.random())


  const dispatch = useDispatch();
  const setMode = (mode) => {
    dispatch(A.setUiMode({mode}));
  }

  const {mode,loginStatus} = useSelector(state => ({
    loginStatus:state.loginInfo.status,
    mode:(state.ui.mode),
  }));

  //const isLoggedIn = useSelector(G.isLoggedIn);
  

  let errorBoundary = app => (
    <ErrorBoundary 
      fallbackRender={({error,resetErrorBoundary,componentStack}) => {

        console.log("HELOOOOOOO?");

        window.__errorHandler(error);
        console.log(error);
        console.log(componentStack);
        console.log("HELOOOOOOO?");

        debugger;

        return (
          <TestFallback 
            resetErrorBoundary={resetErrorBoundary}
        resetAppKey={()=>{
            setMode(ANNOTATION);
            setAppRenderKey(Math.random())
            
          }}/>
        )
      }}>
      {app}
      
    </ErrorBoundary>
  )

  let SvgWrapper = (child) => {
    return (

      <svg viewBox="0 0 10000 8000">
      <foreignObject width="100%" height="100%">
        {child}
      </foreignObject>
    </svg>

    )
  }

 
  if(mode===WELCOME){
    return <WelcomeSceneWrapper {...{setMode}}/>
  }

  let app = (
    <>
    <App {...{mode,setMode}} key={appRenderKey}/>
    </>
  )
  let wrapped = SvgWrapper(app);
  
  return errorBoundary(app);
    


}
